import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import { MERCURE_OPENING_STATUS } from '~/const/orders';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

var CustomProductAddToCartModal = function CustomProductAddToCartModal() {
  return import(
  /* webpackMode: "eager" */
  '~/components/molecules/Product/Modal/CustomProductAddToCartModal.vue');
};

export default {
  name: 'TheCartSection',
  components: {
    CustomProductAddToCartModal: CustomProductAddToCartModal
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread({}, mapActions({
    addCart: 'customer/addCart',
    addCartMercure: 'cart/addCart'
  }), {
    openLayer: function openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'LayerAddToCart',
        products: this.products
      });
      return false;
    },
    addToCart: function () {
      var _addToCart = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var addCartAction;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                addCartAction = this.addCart;

                if (this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[this.locale.iso]) {
                  addCartAction = this.addCartMercure;
                }

                this.openLayer();

                if (!this.products[0]) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return addCartAction({
                  reference: this.products[0].reference,
                  referenceEncoded: btoa(this.products[0].reference),
                  quantity: 1
                });

              case 7:
                if (!this.products[1]) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return addCartAction({
                  reference: this.products[1].reference,
                  referenceEncoded: btoa(this.products[1].reference),
                  quantity: 1
                });

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                if (this.$sentry) {
                  this.$sentry.captureException(_context.t0);
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function addToCart() {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }(),
    closeAction: function closeAction() {
      this.showModal = false;
    }
  })
};